import React from 'react';
import styles from './GlassCard.module.css';

const PADDING_MAP = {
  none: styles['padding-none'],
  sm:   styles['padding-sm'],
  md:   styles['padding-md'],
  lg:   styles['padding-lg'],
};

const GlassCard = ({ 
  children, 
  className = '', 
  hover = false,
  padding = 'md',
  ...props 
}) => {
  const cardClasses = [
    styles.glassCard,
    PADDING_MAP[padding] ?? PADDING_MAP.md,
    hover && styles.hover,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

export default GlassCard;